import { modularizeInsightsResponse } from "../../utils/handleCRMResponse";
import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const getInsightsApi = async (path,startTime,endTime,authHeaders) => {
    const inputData = {
        startDateTime: startTime,
        endDateTime: endTime,
        path: path,
    }
    try {
        const res = await apiCallPost(apiPaths.getInsights, inputData, authHeaders);
        // const modals = await apiCallGet("/crm/dev/get?companyID=01JT5C7MJVABPSSDFXF65NAH5N")
        // const data = modals.data
        // // console.log("data", data)
        // // console.log("modals", modals)
        if (res.data) {
            let insightsData = {};
            insightsData = await modularizeInsightsResponse(res.data.overview);
            return { data: insightsData, status: true }
        }
        return { data: [], status: false, errMsg: 'Some Error Occurred' };
    } catch (err) {
        return { status: false, errMsg: err.message }
    }
}